import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ 'modal', 'overlay', 'wrap', 'close' ];

	openOverlay(e) {
        e.preventDefault();

        const modal = document.getElementById('video-modal');

		if (!modal.hasAttribute('data-group-active')) {
			modal.setAttribute('data-group-active', true);

			document.body.style.overflowY = 'hidden';

			const url = 'https://www.youtube.com/embed/' + this.wrapTarget.dataset.youtube + '?autoplay=1';

			const iframe = this.createYoutubeIframe(url);
			
			const container = document.getElementById('video-modal-container');
			container.append(iframe);
		} 
	}

	closeOverlay(e) {
        e.preventDefault();

		if (e.target == this.overlayTarget || this.closeTarget.contains(e.target)) {
			document.body.style.overflowY = 'auto';
			this.modalTarget.removeAttribute('data-group-active');

			const modalIframe = this.modalTarget.querySelector('iframe');
	
			if (modalIframe) {
			modalIframe.parentElement.removeChild(modalIframe);
			}
		}
	}

	createYoutubeIframe(url) {
		const iframe = document.createElement('iframe');
		iframe.src = url + '&autoplay=0';
		iframe.classList.add('w-full');
		iframe.classList.add('h-full');
		iframe.setAttribute('allowfullscreen', true)

		return iframe;
	}
}